import { useTranslation } from "react-i18next";
import { DataEntryAccidentWitnessProps, typedMemo } from "src/types";
import { FormRow, InputDate, InputText } from "src/ui/widgets";
import { InputPhone } from "src/ui/widgets/input-phone/input-phone";

export const WitnessForm = typedMemo(
  ({
    witness_number,
    formikWitnessValues,
    formikWitnessErrors,
    formikWitnessTouched,
    formik,
    validationSchema,
  }: DataEntryAccidentWitnessProps) => {
    const { t } = useTranslation();

    const { handleChange, handleBlur, setFieldTouched, setFieldValue } = formik;

    const Title = (
      <div className="mb-4">
        {t("commons.witness")} {witness_number + 1}
      </div>
    );

    const Form = (
      <>
        <FormRow
          firstField={
            <InputText
              name={`accidentData.witnessesInfo.witnessesList.${witness_number}.name`}
              handleChange={handleChange}
              handleBlur={handleBlur}
              validationSchema={validationSchema}
              touched={formikWitnessTouched?.name}
              value={formikWitnessValues.name}
              error={formikWitnessErrors?.name}
              label={`${t("commons.name")}`}
              placeholder={t("commons.insert")}
            />
          }
          secondField={
            <InputText
              name={`accidentData.witnessesInfo.witnessesList.${witness_number}.surname`}
              handleChange={handleChange}
              handleBlur={handleBlur}
              validationSchema={validationSchema}
              touched={formikWitnessTouched?.surname}
              value={formikWitnessValues.surname}
              error={formikWitnessErrors?.surname}
              label={`${t("commons.surname")}`}
              placeholder={t("commons.insert")}
            />
          }
        />
        <FormRow
          firstField={
            <InputDate
              name={`accidentData.witnessesInfo.witnessesList.${witness_number}.dateOfBirth`}
              handleChange={handleChange}
              handleBlur={handleBlur}
              setFieldValue={setFieldValue}
              setFieldTouched={setFieldTouched}
              validationSchema={validationSchema}
              touched={formikWitnessTouched?.dateOfBirth}
              value={formikWitnessValues.dateOfBirth}
              error={formikWitnessErrors?.dateOfBirth}
              label={`${t("commons.birth_date")}`}
              placeholder={t("commons.insert")}
              disabledTo={undefined}
              classes="m-0 p-0"
            />
          }
          secondField={
            <InputText
              name={`accidentData.witnessesInfo.witnessesList.${witness_number}.placeOfBirth`}
              handleChange={handleChange}
              handleBlur={handleBlur}
              validationSchema={validationSchema}
              touched={formikWitnessTouched?.placeOfBirth}
              value={formikWitnessValues.placeOfBirth}
              error={formikWitnessErrors?.placeOfBirth}
              label={`${t("commons.birth_palce")}`}
              placeholder={t("commons.insert")}
            />
          }
        />
        <FormRow
          firstField={
            <InputText
              name={`accidentData.witnessesInfo.witnessesList.${witness_number}.fiscalCode`}
              handleChange={handleChange}
              handleBlur={handleBlur}
              validationSchema={validationSchema}
              touched={formikWitnessTouched?.fiscalCode}
              value={formikWitnessValues.fiscalCode}
              error={formikWitnessErrors?.fiscalCode}
              label={`${t("commons.fiscal_code")}`}
              placeholder={t("commons.insert")}
            />
          }
          secondField={
            <InputText
              name={`accidentData.witnessesInfo.witnessesList.${witness_number}.address`}
              handleChange={handleChange}
              handleBlur={handleBlur}
              validationSchema={validationSchema}
              touched={formikWitnessTouched?.address}
              value={formikWitnessValues.address}
              error={formikWitnessErrors?.address}
              label={`${t("commons.address_and_details")}`}
              placeholder={t("commons.insert")}
            />
          }
        />
        <FormRow
          firstField={
            <InputText
              name={`accidentData.witnessesInfo.witnessesList.${witness_number}.email`}
              handleChange={handleChange}
              handleBlur={handleBlur}
              validationSchema={validationSchema}
              touched={formikWitnessTouched?.email}
              value={formikWitnessValues.email}
              error={formikWitnessErrors?.email}
              label={`${t("commons.email_address")}`}
              placeholder={t("commons.insert")}
            />
          }
          secondField={
            <InputPhone
              setFieldTouched={setFieldTouched}
              setFieldValue={setFieldValue}
              name={`accidentData.witnessesInfo.witnessesList.${witness_number}.phoneNumber`}
              touched={formikWitnessTouched?.phoneNumber}
              value={formikWitnessValues.phoneNumber}
              error={formikWitnessErrors?.phoneNumber}
              label={`${t("commons.phone_number")}`}
              placeholder={t("commons.insert")}
            />
          }
        />
      </>
    );

    return (
      <div className={witness_number > 0 ? "mt-4" : ""}>
        {Title}
        {Form}
      </div>
    );
  }
);
